import { useNavigate, useSearchParams } from "react-router-dom";
import { PublicGuard } from "@/components/auth-guard";
import { AuthShell } from "@/components/auth-shell";
import SignUpForm from "@/components/sign-up-form";

export default function SignUp() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const redirectParam = searchParams.get("redirect");
  const redirectPath = redirectParam?.startsWith("/") ? redirectParam : null;

  const handleSwitchToSignIn = () => {
    const nextSearch = redirectPath
      ? `?redirect=${encodeURIComponent(redirectPath)}`
      : "";
    navigate(`/sign-in${nextSearch}`);
  };

  return (
    <PublicGuard>
      <AuthShell
        title="Create an account"
        description="Set up web access for site management, forms, and reporting."
      >
        <SignUpForm
          onSwitchToSignIn={handleSwitchToSignIn}
          redirectPath={redirectPath || undefined}
        />
      </AuthShell>
    </PublicGuard>
  );
}
